import strings from '../../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.parameter.name.label,
  showOnDisabled: () => false,
  validators: []
}

export const form = {
  formKey: "parameterSearch",
  fields: [
    name
  ]
}
